﻿import { debug } from "util";

var vm;

(function () {
    'use strict';

    var controllerId = 'dryreefer';

    angular.module('app.controllers').controller(controllerId, dryreefer)
    dryreefer.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate', '$sce'];

    function dryreefer(common, datacontext, $http, $scope, $stateParams, $translate, $sce) {
        vm = this;

        //Datepickers config
        $('#txtFromDate').datepicker({
            format: 'dd/mm/yyyy'
        });
        $('#txtToDate').datepicker({
            format: 'dd/mm/yyyy'
        });

        vm.Label = "";
        vm.carrierId = 0;
        vm.carrierName = "";
        vm.carrierFilterDisabled = false;

        vm.validFamilies = ['DRY', 'REF'];
        vm.familiesOriginal = [];

        vm.selectOption = { Id: 0, Name: $translate.instant('views.dryreefer.select') };
        vm.listSizeTypeOriginal = [];
        vm.currentYear = (new Date()).getFullYear();

        vm.dryreeferData = [];

        vm.startDate = function () {
            $('#txtFromDate').focus();
        };

        vm.endDate = function () {
            $('#txtToDate').focus();
        };

        function fnConvertDateToSQLFormat(date) {
            var parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        function init() {
            common.activateController().then(function (data) { });
            vm.initializeData();
            vm.setBasicInformation();
            vm.clearCriteria();
            vm.getGeneralFilters();
            vm.getCarriers();
            vm.getdryreeferFilters();
        }

        // # region Filter Functions

        vm.clearCriteria = function () {
            vm.criteria = {
                depotId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                familyIds: [],
                carrierIds: [],
                sizeTypeModel: vm.listSizeType ? (vm.listSizeType.length > 0 ? vm.listSizeType[0] : null) : null,
                dateFrom: null,
                dateTo: null,
                //year: vm.listYears ? (vm.listYears.length > 0 ? vm.listYears[vm.selectCurrentYearIndex()].Id : 0) : 0,
                //weekFrom: vm.listWeek ? (vm.listWeek.length > 0 ? vm.listWeek[0].Id : 0) : 0,
                //weekTo: vm.listWeek ? (vm.listWeek.length > 0 ? vm.listWeek[0].Id : 0) : 0,
            };
        }

        vm.fnSetDefaultDepot = function () {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
                    vm.criteria.depotId = Number(currentYardId);
            }
        }

        vm.getGeneralFilters = function () {
            vm.initializeDepot();
            vm.initializeFamily();

            return datacontext.dryreefer.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.FamilyList != null && data.FamilyList.length > 0) {
                        vm.familiesOriginal = angular.copy(data.FamilyList);
                        angular.forEach(data.FamilyList, function (family, key) {
                            if (vm.validFamilies.indexOf(family.Code) != -1)
                                vm.listFamilies.push({ id: family.Id, label: family.Name });
                        });
                    }

                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.depotId = vm.listDepots[0].Id;
                    }
                    vm.fnSetDefaultDepot();

                    if (data.SizeType !== null && data.SizeType.length > 0) {
                        vm.listSizeType = angular.copy(data.SizeType);
                        vm.listSizeTypeOriginal = angular.copy(data.SizeType);
                        vm.listSizeType.unshift(vm.selectOption);
                        vm.criteria.sizeTypeModel = vm.listSizeType[0];
                    }
                    vm.Label = data.Label;
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getCarriers = function () {
            vm.initializeCarrier();
            return datacontext.dryreefer.getCarrierList().then(function (data) {
                if (data) {
                    angular.forEach(data, function (value, key) {
                        vm.listCarriers.push({ id: value.Id, label: value.Name });
                    });
                    vm.updateCarrierFilter();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getdryreeferFilters = function () {
            vm.initializeYears();
            vm.initializeWeek();

            vm.loadWeekInfo();

            return datacontext.dryreefer.getdryreeferFilters().then(function (data) {
                if (data) {
                    if (data.Years != null && data.Years.length > 0) {
                        vm.listYears = angular.copy(data.Years);
                        vm.criteria.year = vm.listYears[vm.selectCurrentYearIndex()].Id;
                    }
                }

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.loadWeekInfo = function () {
            vm.listWeek = vm.generateYearWeeks();
            vm.listWeek.unshift(vm.selectOption);

            vm.criteria.weekFrom = vm.listWeek[0].Id;
            vm.criteria.weekTo = vm.listWeek[0].Id;
        }

        vm.initializeData = function () {
            vm.dryreeferData = [];

            vm.dryreeferDataSource = new kendo.data.DataSource({
                data: vm.dryreeferData
            });

            vm.gridOptions = {
                dataSource: vm.dryreeferDataSource,
                sortable: false,
                pageable: false,
                groupable: false,
                resizable: true,
                columns: [
                    {
                        title: $translate.instant('views.dryreefer.date'),
                        field: "Date",
                        width: "8%",
                        type: "date",
                        template: '#= kendo.toString(kendo.parseDate(Date,"yyyy-MM-dd"), "dd/MM/yyyy" ) #',
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.dryreefer._20_Dry'),
                        field: "_20_Dry",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Dry}}%</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    {
                        title: $translate.instant('views.dryreefer._40_Dry'),
                        field: "_40_Dry",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Dry}}%</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    //{
                    //    title: $translate.instant('views.dryreefer._20_HC_Dry'),
                    //    field: "_20_HC_Dry",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._20_HC_Dry}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    {
                        title: $translate.instant('views.dryreefer._40_HC_Dry'),
                        field: "_40_HC_Dry",
                        width: "7%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Dry}}%</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    //{
                    //    title: $translate.instant('views.dryreefer._45_HC_Dry'),
                    //    field: "_45_HC_Dry",
                    //    width: "6%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._45_HC_Dry_Color}}' ></span>&nbsp;<strong>{{dataItem._45_HC_Dry}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._20_Reef'),
                    //    field: "_20_Reef",
                    //    width: "6%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Reef}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._20_Open_Top'),
                    //    field: "_20_Open_Top",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._20_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._20_Open_Top}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._40_Reef'),
                    //    field: "_40_Reef",
                    //    width: "6%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Reef}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._40_Hard_Top'),
                    //    field: "_40_Hard_Top",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Hard_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Hard_Top}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._40_Open_Top'),
                    //    field: "_40_Open_Top",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_Open_Top}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    {
                        title: $translate.instant('views.dryreefer._40_HC_Reef'),
                        field: "_40_HC_Reef",
                        width: "6%",
                        template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef}}%</strong>",
                        headerAttributes: {
                            class: "cellInBold"
                        }
                    },
                    //{
                    //    title: $translate.instant('views.dryreefer._40_HC_Reef_CA'),
                    //    field: "_40_HC_Reef_CA",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_CA_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef_CA}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._40_HC_Reef_SF'),
                    //    field: "_40_HC_Reef_SF",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Reef_SF_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Reef_SF}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //},
                    //{
                    //    title: $translate.instant('views.dryreefer._40_HC_Open_Top'),
                    //    field: "_40_HC_Open_Top",
                    //    width: "7%",
                    //    template: "<span style='height: 12px; width: 12px; border-radius: 50%; display: inline-block; background-color:{{dataItem._40_HC_Open_Top_Color}}' ></span>&nbsp;<strong>{{dataItem._40_HC_Open_Top}}%</strong>",
                    //    headerAttributes: {
                    //        class: "cellInBold"
                    //    }
                    //}
                ]
            };
        };

        vm.changeColumns = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");
            switch (vm.criteria.sizeTypeModel.Code) {
                case '22GP':
                    mainReport.showColumn("_20_Dry");
                    mainReport.hideColumn("_40_Dry");
                    mainReport.hideColumn("_40_HC_Dry");
                    mainReport.hideColumn("_40_HC_Reef");
                    break;
                case '42GP':
                    mainReport.hideColumn("_20_Dry");
                    mainReport.showColumn("_40_Dry");
                    mainReport.hideColumn("_40_HC_Dry");
                    mainReport.hideColumn("_40_HC_Reef");
                    break;
                case '40GP':
                    mainReport.hideColumn("_20_Dry");
                    mainReport.hideColumn("_40_Dry");
                    mainReport.showColumn("_40_HC_Dry");
                    mainReport.hideColumn("_40_HC_Reef");
                    break;
                case '45RT':
                    mainReport.hideColumn("_20_Dry");
                    mainReport.hideColumn("_40_Dry");
                    mainReport.hideColumn("_40_HC_Dry");
                    mainReport.showColumn("_40_HC_Reef");
                    break;
                default:
                    mainReport.showColumn("_20_Dry");
                    mainReport.showColumn("_40_Dry");
                    mainReport.showColumn("_40_HC_Dry");
                    mainReport.showColumn("_40_HC_Reef");
                    break;
            };
        }

        vm.setBasicInformation = function () {
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = vm.roleSelected === "COPAdminP" ? true : false;

            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');

            if (associateCarrier && associateCarrier.Name) {
                vm.carrierId = associateCarrier.BusinessPartnerId;
                vm.carrierName = associateCarrier.Name;
            }
        }

        // #region Filters Events

        vm.changeFamily = function () {
            vm.listSizeType = [];

            if (vm.criteria.familyIds === null || vm.criteria.familyIds.length === 0) {
                vm.listSizeType = angular.copy(vm.listSizeTypeOriginal);
            } else {
                angular.forEach(vm.criteria.familyIds, function (family, key) {
                    angular.forEach(vm.listSizeTypeOriginal, function (sizeTypeItem, key2) {
                        var familyCode = vm.getFamilyCodeById(family.id);
                        if (familyCode == sizeTypeItem.Aditional) {
                            vm.listSizeType.push(sizeTypeItem);
                        }
                    });
                });
            }

            vm.listSizeType.unshift(vm.selectOption);
            vm.sizeTypeModel = vm.listSizeType[0];
        };

        // #endregion

        // # endregion

        // #region Helper Functions

        vm.updateCarrierFilter = function () {
            if (vm.listCarriers && vm.carrierId !== 0) {
                vm.listCarriers.forEach(function (value, key) {
                    if (value.id == vm.carrierId) {
                        vm.criteria.carrierIds = [value];
                        vm.carrierFilterDisabled = true;
                    }
                });
            }
            else
                vm.carrierFilterDisabled = false;
        }

        vm.getFamilyCodeById = function (familyId) {
            var family = $(vm.familiesOriginal).filter(function (e, v) { return v.Id == familyId })[0];
            return family ? family.Code : null;
        };

        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.selectCurrentYearIndex = function () {
            return vm.listYears.findIndex(x => x.Id === vm.currentYear);
        }

        vm.generateYearWeeks = function () {
            var weeks = Array.from(new Array(53), (val, index) => index + 1);
            var weeklist = [];
            angular.forEach(weeks, function (value, key) {
                weeklist.push({ Id: value, Name: $translate.instant('views.dryreefer.week') + value });
            });

            return weeklist;
        }

        vm.setDefaultfamiliesWhenEmpty = function () {
            if (vm.criteria.familyIds.length === 0) {
                var dryFamilyId = $(vm.familiesOriginal).filter(function (e, v) { return v.Code === "DRY"; })[0].Id;
                var refFamilyId = $(vm.familiesOriginal).filter(function (e, v) { return v.Code === "REF"; })[0].Id;
                vm.criteria.familyIds.push({ id: dryFamilyId });
                vm.criteria.familyIds.push({ id: refFamilyId });
            }
        };

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");

            if (mainReport) {
                vm.changeColumns();
                mainReport.refresh();
            }
        }

        // #endregion

        // #region Main Functions(Search/Clear)

        vm.clearReport = function () {
            vm.dryreeferData = [];
            vm.dryreeferDataSource = { data: vm.dryreeferData };
            vm.clearCriteria();
            vm.refresReport();
        };

        vm.searchReport = function () {
            //var valid = true;

            //if (vm.criteria.year < vm.currentYear && (vm.criteria.weekFrom === 0 || vm.criteria.weekTo === 0)) {
            //    toastr.info($translate.instant('views.dryreefer.selectSpecificWeekRange'));
            //    valid = false;
            //}

            //if (!valid)
            //    return;

            vm.setDefaultfamiliesWhenEmpty();

            var criteria = {
                depotId: vm.criteria.depotId,
                familyIds: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds),
                carrierIds: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                sizeTypeId: vm.criteria.sizeTypeModel.Id > 0 ? vm.criteria.sizeTypeModel.Id : null,
                dateFrom: fnConvertDateToSQLFormat(vm.criteria.dateFrom),
                dateTo: fnConvertDateToSQLFormat(vm.criteria.dateTo)
            };

            datacontext.dryreefer.getdryreeferList(criteria).then(function (data) {
                if (data.Result === 1) {
                    if (data) {
                        vm.dryreeferData = data.DryReeferResult;
                        vm.setdryreeferDataSource();
                        vm.refresReport();
                    } else {
                        vm.clearReport();
                    }
                }
                else
                    vm.clearReport();
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.setdryreeferDataSource = function () {
            vm.dryreeferDataSource = {
                data: vm.dryreeferData
            };
        }

        vm.exportReport = function () {
            if (vm.dryreeferData.length == 0) {
                toastr.info($translate.instant('views.dryreefer.noDataToExport'));
                return;
            }

            var criteria = {
                depotId: vm.criteria.depotId,
                familyIds: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds),
                carrierIds: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                sizeTypeId: vm.criteria.sizeTypeModel.Id > 0 ? vm.criteria.sizeTypeModel.Id : null,
                year: vm.criteria.year,
                dateFrom: vm.criteria.dateFrom ? fnConvertDateToSQLFormat(vm.criteria.dateFrom) : null,
                dateTo: vm.criteria.dateTo ? fnConvertDateToSQLFormat(vm.criteria.dateTo ): null
            };

            datacontext.dryreefer.getdryreeferListExcel(criteria, "dryreefer");
        };

        // #endregion

        // #region Inicialization Functions

        vm.initializeDepot = function () {
            vm.listDepots = [];
        };

        vm.initializeFamily = function () {
            vm.listFamilies = [];
        };

        vm.initializeCarrier = function () {
            vm.listCarriers = [];
        };

        vm.initializeSizeType = function () {
            vm.listSizeType = [];
        };

        vm.initializeYears = function () {
            vm.listYears = [];
        }

        vm.initializeWeek = function () {
            vm.listWeek = [];
        }

        // #endregion

        init();

        vm.trustAsHtml = function (string) {
            return $sce.trustAsHtml(string);
        };
    }
})();